angular.module('autoremind.communications', ['ngAnimate'])
    .factory('audioService', ['$document', '$sce', '$q', 'dialogs',
    function ($document, $sce, $q, dialogs) {
        var audioElement = null;
        //var audioElement = $document[0].getElementById('audio');
        //audioElement.autoPlay = true; // as per your requirement
        var service = null;
        service = {
            audioElement: audioElement,
            soundSequencesParent: undefined,
            // Clear list of sequences - new will be added as the voice template is loaded
            soundSequences: [],
            currentSequenceScope: undefined,
            duration: 1,
            //var music = document.getElementById('playhead');
            deferred: undefined,
            init: function () {
                if (service.audioElement === null) {
                    service.audioElement = $document[0].getElementById('audio'); // TODO: Inject this either in the view or look for element with specific id - how to ensure single audio? or should we have one per sound sequence?
                    console.log('audioElement', service.audioElement);
                    service.audioElement.autoPlay = true; // as per your requirement
                    service.audioElement.addEventListener('timeupdate', function () {
                        var playPercent = 100 * (service.audioElement.currentTime / service.duration);
                        //playHead.style.marginLeft = playPercent + "%";
                        if (service.currentSequenceScope) {
                            service.currentSequenceScope.setHeadPos(playPercent);
                        }
                    }, false);
                    // Gets audio file duration
                    service.audioElement.addEventListener('canplaythrough', function () {
                        service.duration = service.audioElement.duration;
                    }, false);
                    // 
                    service.audioElement.addEventListener('ended', function () {
                        console.log('audioElement: sequence endded');
                        service.deferred.resolve('ended');
                        service.currentSequenceScope.isPlaying = false;
                        //service.currentSequenceScope = undefined;
                    }, false);
                    service.audioElement.addEventListener('error', function (event) {
                        if (!angular.isDefined(service.currentSequenceScope) || !service.currentSequenceScope.isPlaying) {
                            // If audio file not found we seem to get the error event twice (a few seconds apart, so no need to display alert twice
                            return;
                        }
                        console.log('event.target', event.target.error, event.target.error.MEDIA_ERR_SRC_NOT_SUPPORTED);
                        var errorMessage = 'An unknown media error occurred.';
                        switch (event.target.error.code) {
                            case event.target.error.MEDIA_ERR_ABORTED:
                                errorMessage = 'You aborted the media playback.';
                                break;
                            case event.target.error.MEDIA_ERR_NETWORK:
                                errorMessage = 'A network error caused the media download to fail.';
                                break;
                            case event.target.error.MEDIA_ERR_DECODE:
                                errorMessage = 'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.';
                                break;
                            case event.target.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
                                console.log("mode: " + service.currentSequenceScope.mode);
                                if (service.currentSequenceScope.mode !== undefined && service.currentSequenceScope.mode === 'uuid') {
                                    errorMessage = 'The recorded message could not be found (or network failed). If the duration is 0 there is no recording and we currently only keep recordings for three months.';
                                }
                                else {
                                    errorMessage = 'The sound file is missing or not defined (or file not loaded due to network failure).';
                                }
                                break;
                        }
                        dialogs.error('Error', errorMessage);
                        // Set playing state to stopped (play button will appear again)
                        if (service.currentSequenceScope !== undefined) {
                            service.currentSequenceScope.isPlaying = false;
                        }
                        return service.deferred.reject();
                    }, false);
                }
            },
            // TODO: Extend to allow changing head position
            //http://www.alexkatz.me/html5-audio/building-a-custom-html5-audio-player-with-javascript/
            // Not used anymore - we should delete this (and unit test)
            playTTS: function (text, element, sequenceScope, isInSequence) {
                //var url = 'http://api.voicerss.org/?key=363f493758f1485484da02405429a25d&hl=en-us&c=wav&f=8khz_8bit_mono&r=-4&src=';
                /*
                var url = 'https://audio.autoremind.us/cgi/audio?key=363f43758f1485484da02405&format=mp3&tts=';
                url = $sce.trustAsResourceUrl(url + text);
                return service.playFile(url, element, sequenceScope, isInSequence);
      
                 */
            },
            // Obsolete - we need to include partId
            // Not used anymore - we should delete this
            getRecordingByUuid: function (uuid) {
                var url = '/servlets/audio/messagedata/uuid/' + uuid + '/download/';
                url = $sce.trustAsResourceUrl(url);
                return url;
            },
            // Not used anymore - we should delete this
            getRecordingByUuidAndPartId: function (uuid, partId) {
                var url = '/servlets/audio/messagedata/uuid/' + uuid + '/' + partId + '/download/';
                url = $sce.trustAsResourceUrl(url);
                return url;
            },
            // Obsolete - we need to include partId
            // Not used anymore - we should delete this
            playRecordingByUuid: function (uuid, element, sequenceScope, isInSequence) {
                var url = '/servlets/audio/messagedata/uuid/' + uuid + '/play/';
                url = $sce.trustAsResourceUrl(url);
                return service.playFile(url, element, sequenceScope, isInSequence, 'uuid');
            },
            // Not used anymore - we should delete this
            playRecordingByUuidAndPartId: function (uuid, partId, element, sequenceScope, isInSequence) {
                var url = '/servlets/audio/messagedata/uuid/' + uuid + '/' + partId + '/play/';
                url = $sce.trustAsResourceUrl(url);
                return service.playFile(url, element, sequenceScope, isInSequence, 'uuid');
            },
            // Not used anymore - we should delete this (and unit test)
            playSoundFile: function (sound, element, sequenceScope, isInSequence) {
                /*
                var url = 'https://audio.autoremind.us/cgi/audio?key=363f43758f1485484da02405&format=mp3&sound=';
                url = $sce.trustAsResourceUrl(url + sound);
                return service.playFile(url, element, sequenceScope, isInSequence);
      
                 */
            },
            playSoundID: function (soundid, element, sequenceScope, isInSequence) {
                /*
                var url = 'https://audio.autoremind.us/cgi/audio?key=363f43758f1485484da02405&format=mp3&soundid=';
                url = $sce.trustAsResourceUrl(url + soundid);
                return service.playFile(url, element, sequenceScope, isInSequence);
      
                 */
            },
            playFile: function (url, element, sequenceScope, isInSequence, mode) {
                console.log('play File');
                // TODO: Check if deferred was not resolved and reject?
                service.deferred = $q.defer();
                service.init();
                if (service.currentSequenceScope && service.currentSequenceScope !== sequenceScope) {
                    // Stop any currently playing scope
                    service.currentSequenceScope.disable();
                }
                if (!isInSequence && service.soundSequencesParent.isPlaying)
                    service.soundSequencesParent.stop();
                service.currentSequenceScope = sequenceScope;
                service.currentSequenceScope.setHeadPos(0);
                service.currentSequenceScope.mode = mode;
                service.audioElement.src = url;
                service.audioElement.play();
                return service.deferred.promise;
            },
            play: function (filename) {
                service.audioElement.src = filename;
                service.audioElement.play();
            },
            resume: function () {
                service.audioElement.play();
            },
            pause: function () {
                service.audioElement.pause();
            },
            stop: function () {
                console.log('STOP');
                service.audioElement.pause();
                service.audioElement.src = service.audioElement.currentSrc; // http://stackoverflow.com/a/16978083/1015046
                if (service.soundSequencesParent !== undefined) {
                    service.soundSequencesParent.isPlaying = false;
                }
                //service.currentSequenceScope = undefined;
                return service.deferred.reject();
            },
            incVol: function () {
                if (service.audioElement.volume < 1) {
                    service.audioElement.volume = (service.audioElement.volume + 0.1).toFixed(2);
                }
                return service.audioElement.volume;
            },
            decVol: function () {
                if (service.audioElement.volume > 0) {
                    service.audioElement.volume = (audioElement.volume - 0.1).toFixed(2);
                }
                return service.audioElement.volume;
            },
            timer: function (callback) {
                service.audioElement.ontimeupdate = function () {
                    callback(service.audioElement.duration, service.audioElement.currentTime);
                };
            }
        };
        return service;
    }]);
//# sourceMappingURL=communications.audioservice.js.map